<section class="container regulamin">
  <div class="row">
    <div class="col-lg-12">
      <article class="pl-3 pl-sm-0">
        <h1>{{page.title}}</h1>
        <div class="embed-responsive embed-responsive-16by9">
          <video controls="controls" class="embed-responsive-item" id="video">
            <source *ngFor="let url of page.urls" [src]="url.url" [type]="url.type">
            Twoja przeglądarka nie wspiera tego wideo.
          </video>
        </div>
      </article>
    </div>
  </div>
</section>
<script>
  document.getElementById('video').addEventListener('play', function () {
    gtag({ 'event': '{{page.gtagEvent}}' });
  });
</script>
